import {useContext, useEffect, useState} from "react";
import {Button, Form} from "react-bootstrap";
import logoWhite from '../assets/img/logo-white.png'
import logo from '../assets/img/logo.png'
import './Login.css'
import API, {getMe, HandleError} from "../API";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import {Link, Navigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function PasswordReset() {
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const app = useContext(AppContext)
    const [queryParams, setQueryParams] = useSearchParams();
    const [verified, setVerified] = useState(false);

    const [form, setForm] = useState({
        values: {
            email: queryParams.get('e') ?? '',
            code: queryParams.get('c') ?? '',
            new_password: '',
            trigger: queryParams.get('c')?.length === 8 ? (verified ? 'update' : 'verify') : 'request'
        },
        errorFields: {},
        error: false,
        loading: false,
    })

    const [redirect, setRedirect] = useState('')

    useEffect(() => {
        if(form.values.trigger === 'verify') {
            const verifyCode = async () => {
                setForm({...form, loading: true })
                try {
                    const res = await API({
                        method: 'POST',
                        url: `/password-reset`,
                        data: {...form.values}
                    })

                    if (res.status < 200 || res.status > 299)
                        throw res.data;

                    setForm({...form, loading: false, values: {...form.values, trigger: 'update'}})
                    setVerified(true)
                }
                catch(e) {
                    setForm({...form, loading: false, values: {...form.values, trigger: 'request'}})
                    HandleError(e, 'Error', enqueueSnackbar);
                }
            }
            verifyCode()
        }
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!form.values.email || !form.values.trigger)
            return;

        setForm({...form, loading: true })
        try {
            const res = await API({
                method: 'POST',
                url: `/password-reset`,
                data: {...form.values}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            if(form.values.trigger === 'update') {
                setForm({...form, loading: false})
                enqueueSnackbar(res.data.message, {variant: 'success', style: {whiteSpace: 'pre-line'}});
                setRedirect('/login')
            }
            else {
                setForm({...form, values: {...form.values, trigger: 'requested' }, loading: false})
            }
        }
        catch(e) {
            setForm({...form, loading: false})
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const onChange = (e) => {
        let values = {...form.values}
        values[e.target.name] = e.target.value
        setForm({...form, values: values})
    }

    return (redirect ? <Navigate to={redirect} /> : <div id="page-login">
        <div className="login-banner">
            <div className="center-logo">
                <img src={logoWhite} alt=""/>
            </div>
            <h1>{t('login.heading')}</h1>
        </div>
        <div className="login-form-box">
            <div className="form-inner">
                <div className="login-logo">
                    <img src={logo} alt="" />
                </div>
                <div className="form-login">
                    <h3 className="mb-4">{t('login.lostPassword')}</h3>
                    {form.values.trigger === 'requested' && <p>{t('login.newPasswordRequested')}</p>}
                    {form.values.trigger === 'request' && <form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3 form-floating" controlId="email">
                            <Form.Control type="email" placeholder={t('form.email')} name="email" value={form.values.email} onChange={onChange} />
                            <Form.Label>{t('form.email')}</Form.Label>
                            {'email' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['email']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Button color={"primary"} type="submit">{t('button.requestNewPassword')}</Button>
                    </form>}
                    {form.values.trigger === 'update' && <form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3 form-floating" controlId="new_password">
                            <Form.Control type="password" placeholder={t('form.newPassword')} name="new_password" value={form.values.new_password} onChange={onChange} />
                            <Form.Label>{t('form.newPassword')}</Form.Label>
                            {'new_password' in form.errorFields ? <Form.Text className="text-muted">
                                {form.errorFields['new_password']}
                            </Form.Text> : ''}
                        </Form.Group>
                        <Button color={"primary"} type="submit">{t('button.changePassword')}</Button>
                    </form>}
                </div>
                <div className="login-options">
                    <p>
                        {t('login.alreadyHaveAccount')}?
                        <br />
                        <Link to="/login"><strong>{t('login.link.login')}</strong></Link>
                    </p>
                    <p>
                        {t('login.newAccount')}
                        <br />
                        <Link to="/signup"><strong>{t('button.signup')}</strong></Link>
                    </p>
                    <p className="text-center text-muted small pt-5 pb-5">
                        &copy; TurboTheorie B.V.
                    </p>
                </div>
            </div>
        </div>
    </div>)
}